const InstanceQueryKeys = {
  instance: ["instance"] as const,
};

export { InstanceQueryKeys };
